class RouteTagAssignmentModel extends App.Models.AssignUnassignToRoute {
    modelUrl = 'RouteTagAssignment';
    urlAssignUnassign = "RouteTag";
}

App.Models.RouteTagAssignment = RouteTagAssignmentModel;

/* Collection */
class RouteTagAssignmentCollection extends App.Collections.BaseCollection {
    url = 'RouteTagAssignment';
    model = App.Models.RouteTagAssignment;
}

App.Collections.RouteTagAssignments = RouteTagAssignmentCollection;

class RouteTagAssignmentRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'RouteTagAssignment';
        const model = App.Models.RouteTagAssignment;
        const collectionClass = App.Collections.RouteTagAssignments;

        super(entityName, model, collectionClass);
    }
}

App.Routers.RouteTagAssignment = RouteTagAssignmentRouter;
